import Swiper from 'swiper/swiper-bundle';
import gsap from "gsap";

function timelineSlider() {    

    var galleryTop = new Swiper('.timeline-slider', {
        spaceBetween: 20,
        loop: true,
        loopedSlides: 4,
        noSwiping: false,
        simulateTouch: false,
        centeredSlides: true,
        slidesPerView: 3,
        breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            567: {
              slidesPerView: 2,
              spaceBetween: 5
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20
            },
            1441: {
                slidesPerView: 4,
                spaceBetween: 20
            }
          }
    });
    var galleryThumbs = new Swiper('.timeline-year', {
        spaceBetween: 20,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        loop: true,
        loopedSlides: 4,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            567: {
                slidesPerView: 2,
                spaceBetween: 5
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 20
            }
        }
        
    });
  

    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;


    galleryThumbs.on("slideChangeTransitionStart", function() {
        gsap.fromTo(".timeline-year .swiper-slide.swiper-slide-active .swiper-slide-container span > span", {
            y: 50,
            autoAlpha: 0
        }, {
            duration: 0.8,
            ease: "power3.out",
            y: 0,
            stagger: 0.2,
            autoAlpha: 1,
            clearProps: "all"
        });
    });
   
}

export default timelineSlider;

//module.exports = bannerSlider;